import {action, makeObservable, observable} from 'mobx';
import {trackModalOpen} from '../utils/posthog';

export default class ModalStore {
    initialized = false;

    constructor(initData) {
        this.initialize(initData);

        makeObservable(this, {
            stack: observable,
            addModal: action,
            clearAllModals: action,
            removeTop: action,
        });
    }

    initialize = (initData) => {
        if (initData) {
            this.currentOrgId = initData.currentOrganization.id;
            this.initialized = true;
        }
    };

    serialize = () => {
        return {
            currentOrganization: {
                id: this.currentOrgId,
            }
        }
    }

    stack = [];

    removeTop = () => {
        this.stack.pop();
    };

    addModal = (modalObj) => {
        this.stack.push(modalObj);

        const organizationId = this.currentOrgId;
        const modalProps = modalObj?.props ? Object.keys(modalObj.props) : undefined;

        trackModalOpen(modalObj.type, organizationId, {
            modal_type: modalObj.type,
            modal_props: modalProps,
            stack_depth: this.stack.length,
        });
    };

    clearAllModals = () => {
        this.stack.length = 0;
    };
}

